import React from 'react';
import { Heading, GenericSkeleton } from '@landr/maestro';

const Byline = ({
    isLoading,
    content,
}: {
    isLoading: boolean;
    content?: string;
}) => {
    if (isLoading) {
        return <GenericSkeleton width="200px" height="20px" mt={4} mb={24} />;
    }

    return (
        <Heading as="h3" contrast="low" fontWeight={400}>
            {content}
        </Heading>
    );
};

export default Byline;
